// Minimaler Event-Bus für den Tab-Swipe-Fortschritt (-1..1).
// SwipeableTabs sendet pro Frame, die Bottom-Nav schreibt direkt ins DOM —
// so löst ein Swipe KEIN React-Re-Render des ganzen Bereichs pro Frame aus.
const listeners = new Set();

// meta.commit: Swipe hat den Tab gewechselt (Empfänger übernimmt neue Position ohne Rücksprung)
export function emitSwipeProgress(progress, meta) {
  listeners.forEach((fn) => fn(progress, meta));
}

export function subscribeSwipeProgress(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
